export interface ActividadGrupoEspecie {
  id: number,
  actividad_id: number,
  grupo_especie_id: number
}

export interface ActividadGrupoEspecieBackend {
  actividad_grupos_especie: ActividadGrupoEspecie[];
}

export function createEmptyActividadGrupoEspecie(): ActividadGrupoEspecie {
  return {
    id: null,
    actividad_id: null,
    grupo_especie_id: null    
  };
}

export function createActividadGrupoEspecie(props: any): ActividadGrupoEspecie { 
  return {
    ...createEmptyActividadGrupoEspecie(),
    ...props
  }
}